import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// global imports
import { companyStore, externalStore, userStore } from "../../store/Store";
import DisplayList from "../../components/DisplayList";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";

export default function CompanyDrivers() {
  // global
  const JwtToken = userStore((data) => data.JwtToken);
  const currentCompany = userStore((data) => data.currentCompany);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const setPcCarrierDrivers = externalStore((data) => data.setPcCarrierDrivers);
  const setCompanyDrivers = companyStore((data) => data.setCompanyDrivers);
  const companyDrivers = companyStore((data) => data.companyDrivers);
  
  // local
  const [pending, setPending] = useState(false);
  const [statusCode, setStatusCode] = useState(200);
  const [error, setError] = useState(null);
  const [trigger, setTrigger] = useState(false)
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (JwtToken === "") {
      navigate("/login");
      return;
    }
    const controller = new AbortController();
    setPending(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const ro = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/carrier-drivers/${0}`,
      ro,
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/login");
            setAuthStatus(false);
            return;
          } else if (response.status === 422 || response.status === 429) {
            setStatusCode(response.status);
            return response.json();
          } else {
            setStatusCode(response.status);
            setError("Something went wrong");
            return Promise.resolve();
          }
        }
        return response.json();
      })
      .then((data) => {
        if (data.error) {
          setError(data.message)
          return;
        } else {
          setPending(false);
          setCompanyDrivers(data.carrier_drivers);
          setPcCarrierDrivers(data.pc_carrier_drivers);
        }
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          console.log("The fetch was aborted");
          setPending(false);
          return;
        } else {
          setPending(false);
          setError("Could not load the Data");
        }
      })
      .finally(() => setPending(false));
    return () => {
      controller.abort();
    };
  }, [
    JwtToken,
    navigate,
    id,
    setCompanyDrivers,
    setPcCarrierDrivers,
    setAuthStatus,
    currentCompany,
  ]);
  
  if (pending) {
    return <Loading />;
  } else if (error) {
    return <ErrorDisplay message={error} code={statusCode} />;
  }
  return (
    <div className="container-fluid">
      <DisplayList
        coll={"Company Drivers"}
        docs={companyDrivers}
        trigger={trigger}
        setTrigger={setTrigger}
        setState={setCompanyDrivers}
        statusToggle={true}
      />
    </div>
  );
}
